import { Context, useContext } from 'react';

export function useGetContextOrError<T>(context: Context<T>, name: string): T {
  const c = useContext(context);
  if (c === undefined)
    throw Error(`Cannot retrieve ${name} outside of provider`);
  return c;
}
